/*
  ============================================================
  Produktfinder JavaScript
  ============================================================
  Eine zentrale Datei, die beide Varianten ansteuert:
  - Inline-Section auf Seiten
  - Popup/Drawer mit globalen Triggern
  
  API:
  - window.openProduktfinder()  – öffnet das Popup
  - window.closeProduktfinder() – schließt das Popup
  - data-open-produktfinder     – Attribut für eigene Buttons
  - #produktfinder              – URL-Hash öffnet Popup
*/

(function() {
  'use strict';

  const TOTAL_STEPS = 4;

  /* ============================================================
     KERN-LOGIK – wird von beiden Varianten genutzt
     ============================================================ */
  
  function createFinder(rootEl) {
    if (!rootEl || rootEl.dataset.pfInit === '1') return null;
    rootEl.dataset.pfInit = '1';

    const products = window.PRODUKTFINDER_DATA || [];
    const answers = {};
    let currentStep = 1;

    const stepEls = rootEl.querySelectorAll('.pf-step');
    const progressBar = rootEl.querySelector('.pf-progress-bar');
    const resultsEl = rootEl.querySelector('[data-pf-results]');
    const resultCountEl = rootEl.querySelector('[data-pf-result-count]');
    const restartBtn = rootEl.querySelector('[data-pf-restart]');
    const scrollContainer = rootEl.querySelector('.pf-dialog__body') || null;

    function showStep(n) {
      stepEls.forEach(el => el.classList.remove('pf-step--active'));
      const target = rootEl.querySelector('.pf-step[data-step="' + n + '"]');
      if (target) target.classList.add('pf-step--active');
      const pct = Math.min(100, (n / TOTAL_STEPS) * 100);
      if (progressBar) progressBar.style.width = pct + '%';
      currentStep = n;

      // Scroll-Verhalten je nach Variante
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      } else if (n > 1) {
        // Inline-Variante: smooth scroll an den Anfang
        const top = rootEl.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function reset() {
      Object.keys(answers).forEach(k => delete answers[k]);
      rootEl.querySelectorAll('.pf-option--selected').forEach(el => el.classList.remove('pf-option--selected'));
      showStep(1);
    }

    function matchProducts() {
      const { bike, type, group, budget } = answers;
      return products.filter(p => {
        // Zubehör nicht im Standard-Ergebnis zeigen
        if (p.type && p.type.indexOf('zubehoer') !== -1) return false;
        // Fahrradtyp
        if (bike && p.bike && p.bike.length > 0 && p.bike.indexOf(bike) === -1) return false;
        // Produkttyp
        if (type && type !== 'any' && (!p.type || p.type.indexOf(type) === -1)) return false;
        // Gruppe
        if (group && group !== 'any' && (!p.group || p.group.indexOf(group) === -1)) return false;
        // Budget
        const price = parseFloat(p.price);
        if (!isNaN(price)) {
          if (budget === 'low' && price > 100) return false;
          if (budget === 'mid' && (price < 100 || price > 200)) return false;
          if (budget === 'high' && price < 200) return false;
        }
        return true;
      });
    }

    function renderResults() {
      if (!resultsEl) return;
      const matches = matchProducts();
      resultsEl.innerHTML = '';

      if (matches.length === 0) {
        resultsEl.innerHTML = '<div class="pf-empty"><strong>Hmm, da haben wir leider nichts Passendes.</strong>Versuch es mit anderen Filtern oder schau dir unser komplettes Sortiment an.</div>';
        if (resultCountEl) resultCountEl.textContent = 'Keine Treffer mit diesen Kriterien';
        return;
      }

      if (resultCountEl) {
        resultCountEl.textContent = matches.length + (matches.length === 1 ? ' passendes Produkt für dich' : ' passende Produkte für dich');
      }

      matches.forEach(p => {
        const tagLabel = p.type && p.type.indexOf('helm') !== -1 ? 'Smarter Helm'
          : p.type && p.type.indexOf('universal') !== -1 ? 'Universalgerät' : 'Zubehör';
        const card = document.createElement('a');
        card.className = 'pf-product';
        card.href = p.url;
        card.innerHTML =
          (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" class="pf-product-img" loading="lazy">' : '') +
          '<div class="pf-product-info">' +
            '<span class="pf-product-tag">' + tagLabel + '</span>' +
            '<div class="pf-product-title">' + p.title + '</div>' +
            '<div class="pf-product-price">' + p.priceFormatted + '</div>' +
          '</div>';
        resultsEl.appendChild(card);
      });
    }

    // Option-Klicks
    rootEl.querySelectorAll('.pf-option').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.key;
        const value = this.dataset.value;
        answers[key] = value;

        const stepEl = this.closest('.pf-step');
        stepEl.querySelectorAll('.pf-option').forEach(b => b.classList.remove('pf-option--selected'));
        this.classList.add('pf-option--selected');

        setTimeout(() => {
          if (currentStep < TOTAL_STEPS) {
            showStep(currentStep + 1);
          } else {
            showStep(5);
            renderResults();
          }
        }, 220);
      });
    });

    if (restartBtn) restartBtn.addEventListener('click', reset);

    // Initial
    showStep(1);

    return { reset: reset, showStep: showStep };
  }

  /* ============================================================
     INLINE-VARIANTE
     ============================================================ */

  function initInline() {
    document.querySelectorAll('[data-pf-inline]').forEach(el => createFinder(el));
  }

  /* ============================================================
     POPUP-VARIANTE
     ============================================================ */

  function initPopup() {
    const dialog = document.querySelector('[data-pf-dialog]');
    if (!dialog) return;

    const finder = createFinder(dialog);
    if (!finder) return;

    function openDialog() {
      if (dialog.open) return;
      finder.reset();
      document.body.classList.add('pf-dialog-open');
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog() {
      if (!dialog.open && !dialog.hasAttribute('open')) return;
      dialog.classList.add('pf-dialog--closing');
      setTimeout(() => {
        dialog.classList.remove('pf-dialog--closing');
        document.body.classList.remove('pf-dialog-open');
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }, 280);
    }

    // Trigger-Buttons (data-open-produktfinder)
    document.addEventListener('click', function(e) {
      const opener = e.target.closest('[data-open-produktfinder]');
      if (opener) {
        e.preventDefault();
        openDialog();
        return;
      }
      const closer = e.target.closest('[data-close-produktfinder]');
      if (closer) {
        e.preventDefault();
        closeDialog();
      }
    });

    // Backdrop-Klick schließt
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) closeDialog();
    });

    // ESC-Key
    dialog.addEventListener('cancel', function(e) {
      e.preventDefault();
      closeDialog();
    });

    // Auto-Trigger
    if (window.PRODUKTFINDER_AUTO) {
      const cfg = window.PRODUKTFINDER_AUTO;
      const storageKey = 'pf:auto-shown';
      const alreadyShown = cfg.onceOnly && sessionStorage.getItem(storageKey) === '1';
      if (!alreadyShown) {
        setTimeout(() => {
          if (!dialog.open) {
            openDialog();
            if (cfg.onceOnly) sessionStorage.setItem(storageKey, '1');
          }
        }, cfg.delay * 1000);
      }
    }

    // Hash-Trigger
    if (window.location.hash === '#produktfinder') {
      setTimeout(openDialog, 100);
    }
    window.addEventListener('hashchange', function() {
      if (window.location.hash === '#produktfinder') openDialog();
    });

    // Globale API
    window.openProduktfinder = openDialog;
    window.closeProduktfinder = closeDialog;
  }

  /* ============================================================
     INIT
     ============================================================ */

  function init() {
    initInline();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
